import React, { useEffect } from 'react';
// import { Link } from 'react-router-dom';
import './convocatorias.css';
import { convocatorias_item } from '../../json/convocatoriasItem';

const Convocatorias = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container convocatorias-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='convocatorias_title'>
                        <h1>Convocatorias Publicadas para ser Persona Consejera </h1>
                    </div>
                </div>
            </div>
            <div className='row'>
                {
                    convocatorias_item.map((item, index) => (
                        <div key={index} className='col-md-4 col-sm-6 col-12'>
                            <div className='convocatorias_icono'>
                            <h5>{ item.nombre }</h5>
                                <a href={item.url} >
                                    <img src={"/assets/imgs/" + item.icono} alt='' />
                                </a>
                            </div>
                            <br></br>
                     </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Convocatorias